(function () {
  var config = window.NXEmailPopupConfig || {};
  if (!config.enabled) return;

  var backdrop = document.getElementById('epopBackdrop');
  var modal = document.getElementById('epopModal');
  var form = document.getElementById('epopForm');
  var input = document.getElementById('epopEmailInput');
  var err = document.getElementById('epopErr');
  var submitBtn = document.getElementById('epopSubmit');
  if (!backdrop || !modal || !form) return;

  var KEY = 'ng_popup_v1';
  var DAYS = config.cooldownDays || 30;
  var DELAY = (config.delaySeconds || 45) * 1000;
  var remember = function () { try { localStorage.setItem(KEY, Date.now()); } catch (e) {} };
  var isMobile = window.matchMedia('(max-width: 768px)').matches;

  function openModal() {
    backdrop.classList.add('open');
    modal.classList.add('open');
    if (!isMobile) document.body.style.overflow = 'hidden';
  }
  function closeModal(save) {
    backdrop.classList.remove('open');
    modal.classList.remove('open');
    document.body.style.overflow = '';
    if (save) remember();
  }

  document.getElementById('epopClose').addEventListener('click', function () { closeModal(true); });
  document.getElementById('epopSkip').addEventListener('click', function () { closeModal(true); });
  backdrop.addEventListener('click', function () { closeModal(true); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('open')) closeModal(true);
  });

  // El formulario es el de newsletter de Shopify y se envía de forma normal
  // (así pasa su comprobación anti-robots). Aquí solo se revisa el email antes.
  form.addEventListener('submit', function (e) {
    var email = input.value.trim();
    var ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
    input.setAttribute('aria-invalid', ok ? 'false' : 'true');
    err.textContent = ok ? '' : 'Revisa el email: parece que falta algo.';
    if (!ok) { e.preventDefault(); input.focus(); return; }
    input.value = email;
    remember();
    submitBtn.disabled = true;
    submitBtn.textContent = 'Enviando…';
  });

  // Vuelta de Shopify tras enviar: se abre el pop-up con el resultado
  var stateEl = form.querySelector('[data-epop-state]');
  var state = stateEl ? stateEl.getAttribute('data-epop-state') : '';
  if (state) {
    if (state === 'ok') remember();
    openModal();
    if (window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.delete('customer_posted');
      url.searchParams.delete('contact_posted');
      url.hash = '';
      window.history.replaceState(null, '', url.pathname + url.search);
    }
    return;
  }

  // ?popup=1 en la URL lo abre al momento (para probarlo)
  if (/[?&]popup=1/.test(window.location.search)) { openModal(); return; }

  // Nunca en el carrito, el pago, Personaliza ni el Studio: ahí el cliente ya está decidiendo
  var PAGE = config.pageType;
  var PATH = config.path || window.location.pathname;
  if (PAGE === 'cart' || PAGE === 'checkout') return;
  if (/personaliza|neogripx-studio/.test(PATH)) return;

  var stored = null;
  try { stored = localStorage.getItem(KEY); } catch (e) {}
  if (stored && (Date.now() - parseInt(stored, 10)) < DAYS * 864e5) return;

  // Ordenador: al ir a salir de la página (ratón hacia arriba) o pasado un rato.
  // Móvil: al bajar la mitad de la página.
  var opened = false;
  function openOnce() {
    if (opened) return;
    opened = true;
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('mouseout', onExit);
    openModal();
  }
  function onScroll() {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    if (max > 0 && window.scrollY / max >= 0.5) openOnce();
  }
  var readyAt = Date.now() + 5000;
  function onExit(e) {
    if (!e.relatedTarget && e.clientY <= 0 && Date.now() > readyAt) openOnce();
  }
  if (isMobile) {
    window.addEventListener('scroll', onScroll, { passive: true });
  } else {
    document.addEventListener('mouseout', onExit);
    setTimeout(openOnce, DELAY);
  }
})();
